import { error } from 'protractor';
import { Component, inject, SimpleChanges } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "app/app.component";
import { AlertPopup, config, HttpLoader } from "app/app.config";
import { GroupService } from "app/components/userandgroup/group/group.service";
import { ConfirmationDialogService } from "app/confirmation-dialog/confirmation-dialog.service";
import { DataSharingService } from "app/shared/data-sharing.service";
import { DocumentsService } from "./documents.service";
import { AssistBotService } from "app/components/ai-assist/assist-bot.service";
import { catchError, debounceTime, finalize, Observable, of, Subject, switchMap } from "rxjs";
import { StaffRoomService } from "app/components/staff-room/staff-room.service";
import { ChatService } from "app/components/chat-list/chat.service";
import { UserService } from "app/components/userandgroup/user/user.service";
import { LlmService } from "app/services/llm.service";
import * as _ from 'underscore';
import { HttpErrorResponse } from '@angular/common/http';
import { SecureFileService } from 'app/secure-image/secure-image-service';
import { saveAs as importedSaveAs } from "file-saver";

interface DocumentFolder {
  group_id: number;
  full_name: string;
  data_type: boolean;
  group_icon: string;
  is_private: boolean;
  model_type: number;
  TotalLessonCount: number;
  TotalUserCount: number;
}

interface DocumentItem {
  message_id: number;
  message: string;
  file_type: string;
  file_size: string;
  createdAt: string;
  folderId: number;
  folderName: string;
  summary?: string;
  view_url?: string;
  is_publish: boolean;
  is_question_found: boolean;
  is_survey_found: boolean;
  is_polls_found: boolean;
  is_notes_found: boolean;
}

@Component({
  selector: "app-documents",
  standalone: false,
  templateUrl: "./documents.component.html",
  styleUrl: "./documents.component.scss",
})
export class DocumentsComponent {

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private dataSharingService = inject(DataSharingService);
  private groupService = inject(GroupService);
  private appComponent = inject(AppComponent);
  private documentService = inject(DocumentsService);
  private assistBotService = inject(AssistBotService);
  private staffRoomService = inject(StaffRoomService);
  private chatService = inject(ChatService);
  private userservice = inject(UserService);
  private llmService = inject(LlmService);

  private secureFileService = inject(SecureFileService);


  // @HostBinding('class.flex-grid') leftBarClass = true;
  // @HostBinding('style.width') flexwidth = '100%';

  // @ViewChild('documentRecordList', { static: true}) private documentScrollContainer: ElementRef


  activeUrl: any;

  folders: DocumentFolder[] = [];

  selectedFolderId: number | null = null;

  folderSearch = '';

  showBtnSpinner: boolean = false;


  showFolderModal = false;

  documents: DocumentItem[] = [];

  editedData: any[] = [];

  documentSearch = '';

  selectedDocument: DocumentItem | null = null;

  viewMode: 'grid' | 'list' = 'grid';

  getFolderDocumentList: any[] = [];

  documentCount: number = 0;
  userCount: number = 0;

  activeDocumentMenu: number | string | null = null;

  editingFolderId: number | string | null = null;

  previewIndex = 0;

  inputSrc: any = '';
  selectedReadFile: any = '';
  mediaContent: any = '';

  // =====================================================
  // MODALS
  // =====================================================

  showSummaryModal = false;

  showPreviewModal = false;

  summaryLoading = false;

  isFolderSidebarCollapsed = false;

  editedMessageId: number = 0;

  sortBy = 'message';
  showSearchSec = true;
  totalUserCount: number = 0;
  searchInList = new Subject<any>();
  listSortBy = 'updatedAt';
  isUserRole: number | null = null;
  isUserDetail: any;
  search: string = '';

  offset: number = config.DEFAULT_OFFSET;
  limit: number = config.DEFAULT_RECORD_LIMIT;

  modalScrollDistance = config.DEFAULT_SCROLL_DIST;
  modalScrollThrottle = config.SCROLL_THROTTLE;

  newFolderName = '';
  newFolderDescription = '';
  newFolderModelType = '';
  newFolderAccess = 'users';

  isEditFolder = false;

  selectedFolderUsers: any[] = [];

  listOfUsers: any[] = [];
  userSearch = '';

  selectedDocuments: any[] = [];

  selectedAssessmentDocument: any = null;
  showAssessmentModal = false;

  selectedSurveyDocument: any = null;
  showSurveyModal = false;

  showExcelEditor = false;

  companyIdForConversion: any = '';

  message_id: any = '';

  selectedClassList: any[] = [];

  isDownload: boolean = false;

  documentId: any;
  documentFileName: any;
  documentFileType: any;
  documentTitle: any;
  upLoadedFileList: any[] = [];
  activeFolderModelType: any;
  selectedPolicy: any;
  docTrainId: any;
  showEditor: boolean = false;

  isFolderLoading = false;



  constructor(
    private httpLoader: HttpLoader,
    private alert: AlertPopup,
    private confirmDialogService: ConfirmationDialogService
  ) { }



  ngOnInit(): void {

    this.searchInList
      .pipe(
        debounceTime(500)
      )
      .subscribe((event: any) => {

        this.search = event?.target?.value?.trim() || '';

        this.loadFolders(0);
      });

    const role = localStorage.getItem('user_role');

    this.isUserRole = Number(role?.replace(/"/g, ''));

    console.log(this.isUserRole);        // 2
    console.log(typeof this.isUserRole); // number



    this.loadFolders(0);

    this.route.paramMap.subscribe(params => {

      const groupId = params.get('groupId');

      this.selectedFolderId = groupId
        ? Number(groupId)
        : null;

      // console.log('URL Group ID:', this.selectedFolderId);

      if (this.selectedFolderId) {
        this.loadDocuments();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (
      changes['documentId'] &&
      this.documentId
    ) {
      this.loadExistingDocument();
    }

  }


  private loadExistingDocument(): void {

    console.log(
      'Loading existing document:',
      this.documentId
    );

    // this.documentService
    //   .getDocumentById(this.documentId)
    //   .subscribe({
    //     next: (response: any) => {

    //       console.log(
    //         'Existing document response:',
    //         response
    //       );

    //       // Populate Excel editor
    //       this.loadExcelData(response);

    //     },

    //     error: (error) => {
    //       console.error(
    //         'Unable to load document:',
    //         error
    //       );
    //     }
    //   });
  }

  get isAdminRole(): boolean {
    return this.isUserRole === 1 || this.isUserRole === 2;
  }


  toggleFolderSidebar(): void {
    this.isFolderSidebarCollapsed =
      !this.isFolderSidebarCollapsed;
  }

  // =====================================================
  // FOLDERS
  // =====================================================

  loadFolders(pageNo: number): void {

    if (pageNo !== 0) {
      return;
    }

    this.offset = 0;

    this.listSortBy =
      this.sortBy === 'time'
        ? 'updatedAt'
        : 'full_name';

    const payload = {
      offset: this.offset,
      limit: this.limit,
      search: this.search || '',
      sort: this.listSortBy,
      data_type: true
    };

    // SHOW LOADER
    this.httpLoader.showLoader();

    this.staffRoomService
      .getClassList(payload)
      .pipe(
        finalize(() => {
          // ALWAYS HIDE LOADER
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          const result =
            response?.result ??
            response?.chatList ??
            [];

          this.folders = Array.isArray(result)
            ? result
            : [];

          const routeGroupId =
            this.route.snapshot.paramMap.get('groupId');

          if (
            !routeGroupId &&
            this.folders.length > 0
          ) {
            const firstActiveFolder =
              this.folders.find(
                (folder: any) =>
                  folder.group_active === true ||
                  folder.group_active === 1
              ) ?? this.folders[0];

            if (firstActiveFolder?.group_id) {

              const groupId =
                Number(firstActiveFolder.group_id);

              this.selectedFolderId = groupId;

              this.router.navigate([
                '/documentnew',
                groupId
              ]);
            }
          }
        },

        error: (error: any) => {

          console.error(
            'Failed to load folders:',
            error
          );

          this.folders = [];

          this.alert.showAlertMessage({
            message:
              error?.error?.message ||
              error?.message ||
              'Failed to load document folders.'
          });
        }
      });
  }


  get filteredFolders(): DocumentFolder[] {

    const search = (this.folderSearch || '')
      .trim()
      .toLowerCase();

    if (!search) {
      return this.folders || [];
    }

    return (this.folders || []).filter(
      folder =>
        (folder.full_name || '')
          .toLowerCase()
          .includes(search)
    );
  }


  selectFolder(folderId: number): void {
    if (!folderId) {
      return;
    }

    this.selectedFolderId = Number(folderId);

    this.documents = [];
    this.selectedDocuments = [];

    this.activeDocumentMenu = null;

    this.router.navigate([
      '/documentnew',
      this.selectedFolderId
    ]);
  }


  get selectedFolderName(): string {

    if (!this.selectedFolderId) {
      return 'All Documents';
    }

    const folder =
      this.folders.find(
        item =>
          item.group_id === this.selectedFolderId
      );

    return folder?.full_name || 'Documents';

  }

  get SelectFolderModelType(): any {
    if (!this.selectedFolderId) {
      return 'All Documents';
    }

    const folder =
      this.folders.find(
        item =>
          item.group_id === this.selectedFolderId
      );

    return folder?.model_type || 'Documents';
  }

  get LoggedUserRoleId(): any {

    console.log(this.isUserRole, '::::::::User:::::::::::::');

    return this.isUserRole;

  }

  navigate(mode: string): void {

    // ==========================================
    // AI VOICE / CONVERSATION
    // ==========================================
    if (mode === 'conversation') {
      this.llmService.llm_bot_payload.mode = mode;

      this.router.navigate(['/aivoice']);
      return;
    }

    // ==========================================
    // DOCUMENT SELECTION VALIDATION
    // ==========================================
    const selectedDocs =
      this.llmService.selectedDoc_ids || [];

    if (selectedDocs.length === 0) {
      this.alert.showAlertMessage({
        message: 'Please select document'
      });
      return;
    }

    // ==========================================
    // SET LLM PAYLOAD
    // ==========================================
    this.llmService.llm_bot_payload.mode = mode;

    this.llmService.llm_bot_payload.document_id = [
      ...selectedDocs
    ];

    // ==========================================
    // NAVIGATE
    // ==========================================
    if (mode === 'answer') {
      this.router.navigate(['/aiassist']);
      return;
    }
  }



  get filteredUsers(): any[] {
    const search = (this.userSearch || '')
      .trim()
      .toLowerCase();

    if (!search) {
      return this.listOfUsers || [];
    }

    return (this.listOfUsers || []).filter((user: any) => {

      const name =
        `${user.first_name || ''} ${user.last_name || ''}`
          .toLowerCase();

      const email =
        (user.email || '').toLowerCase();

      return (
        name.includes(search) ||
        email.includes(search)
      );
    });
  }


  isUserSelected(user: any): boolean {

  const userId =
    user?.user_id ??
    user?.userId ??
    user?.id;

  if (userId == null) {
    return false;
  }

  return this.selectedFolderUsers
    .map(id => String(id))
    .includes(String(userId));
}

  
toggleUser(userId: number | string): void {
  const id = String(userId);

  const index = this.selectedFolderUsers.findIndex(
    selectedId => String(selectedId) === id
  );

  if (index !== -1) {
    // Remove user
    this.selectedFolderUsers.splice(index, 1);
  } else {
    // Add user
    this.selectedFolderUsers.push(id);
  }

  // Force Angular change detection
  this.selectedFolderUsers = [
    ...this.selectedFolderUsers
  ];
}



  onUserCheckboxChange(
    userId: number | string,
    event: Event
  ): void {
    const checkbox = event.target as HTMLInputElement;
    const id = String(userId);

    if (checkbox.checked) {

      if (
        !this.selectedFolderUsers.some(
          selectedId => String(selectedId) === id
        )
      ) {
        this.selectedFolderUsers.push(userId);
      }

    } else {

      this.selectedFolderUsers =
        this.selectedFolderUsers.filter(
          selectedId => String(selectedId) !== id
        );

    }
  }

  clearSelectedUsers(): void {
    this.selectedFolderUsers = [];
  }

  getUserInitials(user: any): string {

    const first =
      user.first_name?.charAt(0) || '';

    const last =
      user.last_name?.charAt(0) || '';

    return (
      first + last
    ).toUpperCase();
  }


  closeFolderModal(): void {
    this.showFolderModal = false;
    this.resetFolderForm();
  }




  // createFolder(): void {

  //   if (this.showBtnSpinner) {
  //     return;
  //   }

  //   const folderName = (this.newFolderName || '').trim();

  //   if (!folderName) {
  //     this.alert.showAlertMessage({
  //       message: 'Please enter a document folder name.'
  //     });
  //     return;
  //   }

  //   if (this.selectedFolderUsers.length === 0) {
  //     this.alert.showAlertMessage({
  //       message:
  //         'Please choose at least one employee for this document folder.'
  //     });
  //     return;
  //   }

  //   const loggedUserId = Number(localStorage.getItem('user_id') ?? 0);

  //   const payload = {
  //     chat_group_name: folderName,
  //     chat_description:
  //       this.newFolderDescription?.trim() || '',
  //     model_type: this.newFolderModelType,
  //     user_ids: [...this.selectedFolderUsers, loggedUserId],
  //     data_type: true
  //   };

  //   this.showBtnSpinner = true;
  //   this.httpLoader.showLoader();

  //   this.chatService
  //     .createGroup(payload)
  //     .pipe(
  //       finalize(() => {

  //         this.showBtnSpinner = false;
  //         this.httpLoader.hideLoader();

  //       })
  //     )
  //     .subscribe({

  //       next: (response: any) => {

  //         console.log(
  //           'Create Folder Response:',
  //           response
  //         );

  //         this.alert.showAlertMessage({
  //           message:
  //             response?.message ||
  //             'Document folder created successfully.'
  //         });

  //         this.newFolderName = '';
  //         this.newFolderDescription = '';
  //         this.newFolderModelType = '';
  //         this.selectedFolderUsers = [];

  //         this.closeFolderModal();

  //         this.loadFolders(0);
  //       },

  //       error: (err: any) => {

  //         console.error(
  //           'Create Folder Error:',
  //           err
  //         );

  //         this.alert.showAlertMessage({
  //           message:
  //             err?.error?.message ||
  //             err?.message ||
  //             'An error occurred while creating the document folder.'
  //         });
  //       }

  //     });
  // }


  createFolder(): void {
    const folderName = this.newFolderName?.trim();

    if (!folderName) {
      this.alert.showAlertMessage({
        message: 'Please enter a document folder name.'
      });
      return;
    }

    if (!this.newFolderModelType) {
      this.alert.showAlertMessage({
        message: 'Please select a model type.'
      });
      return;
    }

    if (
      this.newFolderAccess === 'users' &&
      this.selectedFolderUsers.length === 0
    ) {
      this.alert.showAlertMessage({
        message: 'Please select at least one user.'
      });
      return;
    }

    if (this.showBtnSpinner) {
      return;
    }

    if (this.isEditFolder) {
      this.updateFolder();
    } else {
      this.saveNewFolder();
    }
  }

  saveNewFolder(): void {
    if (this.showBtnSpinner) {
      return;
    }

    const folderName = this.newFolderName?.trim();

    if (!folderName) {
      this.alert.showAlertMessage({
        message: 'Please enter a document folder name.'
      });
      return;
    }

    if (!this.newFolderModelType) {
      this.alert.showAlertMessage({
        message: 'Please select a model type.'
      });
      return;
    }

    if (
      this.newFolderAccess === 'users' &&
      this.selectedFolderUsers.length === 0
    ) {
      this.alert.showAlertMessage({
        message: 'Please select at least one user.'
      });
      return;
    }

    const userIds = this.selectedFolderUsers.map(
      (user: any) =>
        typeof user === 'object'
          ? user?.user_id
          : user
    );

    const payload = {
      chat_group_name: folderName,
      chat_description:
        this.newFolderDescription?.trim() || '',
      data_type: true,
      model_type: String(this.newFolderModelType),
      access_type: this.newFolderAccess,
      user_ids:
        this.newFolderAccess === 'users'
          ? userIds
          : []
    };

    console.log('Create folder payload:', payload);

    this.showBtnSpinner = true;
    this.httpLoader.showLoader();

    this.chatService
      .createGroup(payload)
      .pipe(
        finalize(() => {
          this.showBtnSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (response?.success === false) {
            this.alert.showAlertMessage({
              message:
                response?.message ||
                'Unable to create folder.'
            });
            return;
          }

          this.alert.showAlertMessage({
            message:
              response?.message ||
              'Document folder created successfully.'
          });

          this.closeFolderModal();
          this.resetFolderForm();
          this.loadFolders(0);
        },

        error: (error: any) => {
          console.error(
            'Create folder error:',
            error
          );

          this.alert.showAlertMessage({
            message:
              error?.error?.message ||
              error?.message ||
              'Something went wrong while creating the folder.'
          });
        }
      });
  }

  resetFolderForm(): void {
    this.newFolderName = '';
    this.newFolderDescription = '';
    this.newFolderModelType = '';
    this.newFolderAccess = 'users';

    this.selectedFolderUsers = [];
    this.userSearch = '';

    this.editingFolderId = null;
    this.isEditFolder = false;
  }


  updateFolder(): void {
    if (this.showBtnSpinner) {
      return;
    }

    const folderName =
      this.newFolderName?.trim();

    if (!this.editingFolderId) {
      this.alert.showAlertMessage({
        message: 'Invalid document folder.'
      });
      return;
    }

    if (!folderName) {
      this.alert.showAlertMessage({
        message: 'Please enter a document folder name.'
      });
      return;
    }

    if (!this.newFolderModelType) {
      this.alert.showAlertMessage({
        message: 'Please select a model type.'
      });
      return;
    }

    if (
      this.newFolderAccess === 'users' &&
      this.selectedFolderUsers.length === 0
    ) {
      this.alert.showAlertMessage({
        message: 'Please select at least one user.'
      });
      return;
    }

    const userIds =
      this.selectedFolderUsers.map(
        (user: any) =>
          typeof user === 'object'
            ? user?.user_id
            : user
      );

    const payload = {
      group_id: this.editingFolderId,

      chat_group_name: folderName,

      chat_description:
        this.newFolderDescription?.trim() || '',

      model_type:
        Number(this.newFolderModelType),

      data_type: true,

      access_type:
        this.newFolderAccess,

      user_ids:
        this.newFolderAccess === 'users'
          ? userIds
          : []
    };

    console.log(
      'Update folder payload:',
      payload
    );

    this.showBtnSpinner = true;
    this.httpLoader.showLoader();

    this.chatService
      .updateChatGroup(payload)
      .pipe(
        finalize(() => {
          this.showBtnSpinner = false;
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (response?.success === false) {
            this.alert.showAlertMessage({
              message:
                response?.message ||
                'Unable to update folder.'
            });
            return;
          }

          this.alert.showAlertMessage({
            message:
              response?.message ||
              'Document folder updated successfully.'
          });

          this.closeFolderModal();
          this.resetFolderForm();
          this.loadFolders(0);
        },

        error: (error: any) => {
          console.error(
            'Update folder error:',
            error
          );

          this.alert.showAlertMessage({
            message:
              error?.error?.message ||
              error?.message ||
              'Something went wrong while updating the folder.'
          });
        }
      });
  }

  deleteFolder(folder: any): void {
    const folderId = folder?.group_id;

    if (!folderId) {
      this.alert.showAlertMessage('Invalid document folder.');
      return;
    }

    this.confirmDialogService.openConfirmDialog('', {
      title: 'Confirmation',
      message: `Are you sure you want to delete this "${folder.full_name}" Document?`,
      btnOkText: 'YES',
      btnCancelText: 'NO',

      onClose: (confirmed: boolean) => {
        if (!confirmed) {
          return;
        }

        this.httpLoader.showLoader();

        // Find folder index correctly
        const index = _.findIndex(
          this.folders,
          (item: any) => item.group_id === folderId
        );

        if (index === -1) {
          this.httpLoader.hideLoader();
          this.alert.showAlertMessage('Document folder not found.');
          return;
        }

        this.groupService.deleteSelectedGroup(folderId).subscribe({
          next: (response: any) => {
            this.httpLoader.hideLoader();

            // Remove folder from UI
            this.folders.splice(index, 1);

            // If deleted folder was selected
            if (this.selectedFolderId === folderId) {
              this.selectedFolderId = null;
              this.documents = [];
            }

            this.alert.showAlertMessage(
              response?.message || 'Document folder deleted successfully.'
            );
          },

          error: (error: any) => {
            this.httpLoader.hideLoader();

            console.error('Delete folder error:', error);

            this.alert.showAlertMessage(
              error?.error?.message ||
              error?.error ||
              error?.message ||
              'Error deleting document folder.'
            );
          }
        });
      }
    });
  }


  // =====================================================
  // DOCUMENTS
  // =====================================================

  loadDocuments(): void {

    if (!this.selectedFolderId) {
      this.documents = [];
      this.httpLoader.hideLoader();
      return;
    }

    const payLoad = {
      offset: this.offset,
      limit: this.limit,
      groupId: this.selectedFolderId,
      is_doc_section: true
    };

    this.httpLoader.showLoader();

    this.chatService
      .getMessageAttachments(payLoad)
      .pipe(
        finalize(() => {
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          this.userCount =
            response?.TotalUserCount ?? 0;

          const recordList =
            Array.isArray(response?.recordList)
              ? response.recordList
              : [];

          if (this.offset === 0) {
            this.documents = recordList;
          } else {
            this.documents = [
              ...(this.documents || []),
              ...recordList
            ];
          }

          this.dataSharingService
            .emitLessonsRecords(response);
        },

        error: (error: any) => {

          console.error(
            'Failed to load documents:',
            error
          );

          this.documents = [];

          this.alert.showAlertMessage({
            message:
              error?.error?.message ||
              error?.message ||
              'Failed to load documents.'
          });
        }
      });
  }


  get filteredDocuments(): DocumentItem[] {

    let result = [
      ...(this.documents || [])
    ];


    // ==========================================
    // SEARCH FILTER
    // ==========================================

    const search =
      (this.documentSearch || '')
        .trim()
        .toLowerCase();


    if (search) {

      result = result.filter(
        (document: DocumentItem) =>
          (document.message || '')
            .toLowerCase()
            .includes(search)
      );

    }


    return result;
  }


  get totalDocuments(): number {

    return this.documents.length;

  }


  // =====================================================
  // UPLOAD
  // =====================================================

  openUploadDocument(): void {
    if (!this.selectedFolderId) {
      console.log('Please select a folder');
      return;
    }

    this.router.navigate([
      '/documentnew/upload',
      this.selectedFolderId
    ]);
  }


  // =====================================================
  // ASK QUESTION
  // =====================================================

  askQuestion(): void {

    if (!this.selectedFolderId) {
      return;
    }

    this.router.navigate(
      ['/ask-question'],
      {
        queryParams: {
          folderId: this.selectedFolderId
        }
      }
    );

  }


  // =====================================================
  // SUMMARY
  // =====================================================

  openSummary(
    document: DocumentItem
  ): void {

    this.selectedDocument = document;

    this.showSummaryModal = true;

    this.summaryLoading = false;

  }


  closeSummary(): void {

    this.showSummaryModal = false;

    this.selectedDocument = null;

  }


  // =====================================================
  // FILE ICON
  // =====================================================

  getFileIcon(
    type: string
  ): string {

    switch (type?.toLowerCase()) {

      case 'pdf':
        return 'pi-file-pdf';

      case 'doc':
      case 'docx':
        return 'pi-file-word';

      case 'xls':
      case 'xlsx':
        return 'pi-file-excel';

      case 'ppt':
      case 'pptx':
        return 'pi-file';

      default:
        return 'pi-file';

    }

  }


  getFileClass(fileExt: string): string {
    const type = (fileExt || '').toLowerCase();

    if (type.includes('pdf')) {
      return 'pdf';
    }

    if (type.includes('doc')) {
      return 'doc';
    }

    if (type.includes('xls')) {
      return 'xls';
    }

    if (type.includes('ppt')) {
      return 'ppt';
    }

    if (type.includes('mp3')) {
      return 'mp3'
    }

    return 'default';
  }


  toggleDocumentMenu(event: Event, document: any): void {
    event.stopPropagation();

    if (this.activeDocumentMenu === document.message_id) {
      this.activeDocumentMenu = null;
    } else {
      this.activeDocumentMenu = document.message_id;
    }
  }




  editDocument(document: any): void {
    this.activeDocumentMenu = null;

    console.log('Edit existing document:', document);

    // =====================================================
    // BASIC DOCUMENT INFORMATION
    // =====================================================

    this.documentId = document.id ?? document.documentId ?? document.document_id;

    this.documentFileName =
      document.file_name ??
      document.fileName ??
      document.filename ??
      document.name ??
      '';

    this.documentFileType =
      document.file_type ??
      document.fileType ??
      document.mime_type ??
      '';

    this.documentTitle =
      document.document_title ??
      document.documentTitle ??
      document.title ??
      this.documentFileName;

    // =====================================================
    // EXISTING DOCUMENT FILE
    // =====================================================

    this.upLoadedFileList = [];

    if (document.file) {
      this.upLoadedFileList = [document.file];
    } else if (document.file_url) {
      this.upLoadedFileList = [{
        name: this.documentFileName,
        url: document.file_url,
        file_url: document.file_url,
        type: this.documentFileType
      }];
    }

    // =====================================================
    // COMPANY / FOLDER / MODEL
    // =====================================================

    this.companyIdForConversion =
      document.company_id ??
      document.companyId ??
      this.companyIdForConversion;

    this.selectedFolderId =
      document.folderId ??
      document.group_id ??
      document.groupId ??
      this.selectedFolderId;

    this.activeFolderModelType =
      document.model_type ??
      document.modelType ??
      this.activeFolderModelType;

    // =====================================================
    // OTHER DOCUMENT DATA
    // =====================================================

    this.selectedPolicy =
      document.stateCode ??
      document.state_code ??
      document.policy ??
      this.selectedPolicy;

    this.docTrainId =
      document.docTrainId ??
      document.doc_train_id ??
      document.training_id ??
      null;

    this.message_id =
      document.messageId ??
      document.message_id ??
      null;

    this.isDownload =
      document.isDownload ??
      false;

    // Existing users/class list
    this.selectedClassList =
      document.chatUserList ??
      document.chat_user_list ??
      [];

    // =====================================================
    // OPEN EDITOR
    // =====================================================

    this.showEditor = true;
    this.showExcelEditor = true;
  }

  onExcelEditorSave(event: any): void {
    console.log('Excel editor saved:', event);

    this.showExcelEditor = false;
    this.showEditor = false;

    // Refresh documents if required
    this.loadDocuments();
  }

  closeExcelEditor(): void {
    this.showExcelEditor = false;
    this.selectedDocument = null;
  }

  downloadDocument(document: any): void {
    try {
      const url = document.download_url;

      if (url) {
        document.startFileDownload = true;

        this.secureFileService.secureFileDownLoad(url).subscribe(
          (blob) => {
            document.startFileDownload = false;
            importedSaveAs(blob, document.file_id);
          },
          (error: HttpErrorResponse) => {
            document.startFileDownload = false;
            console.log(error);
            this.alert.showAlertMessage(error.error);
          }
        );
      }
    } catch (error) {
      this.httpLoader.hideLoader();

      console.log(error);

    }
  }

  //Assessment popup
  openAssessment(document: any): void {
    this.activeDocumentMenu = null;

    console.log('Assessment:', document);

    this.selectedAssessmentDocument = document;
    this.showAssessmentModal = true;
  }

  closeAssessment(): void {
    this.showAssessmentModal = false;
    this.selectedAssessmentDocument = null;
  }

  //Survey Popup
  openSurvey(document: any): void {
    this.activeDocumentMenu = null;

    console.log('Survey:', document);

    this.selectedSurveyDocument = document;
    this.showSurveyModal = true;
  }

  closeSurvey(): void {
    this.showSurveyModal = false;
    this.selectedSurveyDocument = null;
  }

  surveySaved(survey: any): void {
    console.log('Survey saved:', survey);

    this.showSurveyModal = false;
    this.selectedSurveyDocument = null;

    this.alert.showAlertMessage({
      message: 'Survey created successfully'
    });
  }

  //Poll popup
  openPoll(document: any): void {
    this.activeDocumentMenu = null;

    console.log('Poll:', document);

    // this.router.navigate(['/poll', document.id]);
  }

  openNotes(document: any): void {
    this.activeDocumentMenu = null;

    console.log('Notes:', document);

    // this.router.navigate(['/notes', document.id]);
  }

  deleteDocument(item: any): void {
    const messageId = item?.message_id;
    const title = item?.message || 'Document';

    if (!messageId) {
      this.alert.showAlertMessage({
        message: 'Invalid document.'
      });
      return;
    }

    this.confirmDialogService.openConfirmDialog('', {
      title: 'Confirmation',
      message: 'Do you want to delete the file?',
      btnOkText: 'DELETE',
      btnCancelText: 'NO',

      onClose: (confirmed: boolean) => {
        if (!confirmed) {
          return;
        }

        this.httpLoader.showLoader();

        this.getDeleteObservable(item, title)
          .pipe(
            catchError((error) => {
              console.error(
                'LLM document deletion failed:',
                error
              );

              // Continue with message deletion.
              return of(null);
            }),

            switchMap(() =>
              this.chatService.deleteMessage(messageId)
            ),

            finalize(() =>
              this.httpLoader.hideLoader()
            )
          )
          .subscribe({
            next: (response: any) => {

              if (
                response?.status === true ||
                response?.success === true
              ) {
                this.onDeleteSuccess(
                  messageId,
                  title
                );
              } else {
                this.alert.showAlertMessage({
                  message:
                    response?.message ||
                    'Unable to delete document.'
                });
              }
            },

            error: (error: any) => {
              console.error(
                'Delete document error:',
                error
              );

              this.alert.showAlertMessage({
                message:
                  error?.error?.message ||
                  error?.message ||
                  'Cannot delete document.'
              });
            }
          });
      }
    });
  }

  private getDeleteObservable(item: any, title: any): Observable<any> {

    let message: any = title;

    if (!item.is_llm_training) {
      return of(null);
    }

    // if (this.modelType === 1) {
    //   return this.llmService.llmdeleteBydocId(item.llmfile_uuid);
    // }

    return this.llmService.llmTrainDocDelete(item.llmfile_uuid);
  }


  private onDeleteSuccess(messageId: number, title: any) {
    this.alert.showAlertMessage({ message: `${title} file deleted successfully` });

    const index = this.documents.findIndex(
      (x: any) => x.message_id === messageId
    );

    if (index !== -1) {
      this.documents.splice(index, 1);
    }

    this.loadDocuments();
  }

  previewDocument(document: any): void {
    const index = this.filteredDocuments.findIndex(
      (item: any) =>
        item.message_id === document.message_id
    );

    this.previewIndex = index >= 0 ? index : 0;

    this.selectedDocument =
      this.filteredDocuments[this.previewIndex];

    this.showPreviewModal = true;

    this.loadDocumentPreview(this.selectedDocument);
  }

  selectPreviewDocument(
    document: any,
    index: number
  ): void {

    this.previewIndex = index;
    this.selectedDocument = document;

    this.loadDocumentPreview(document);
  }

  previousPreview(): void {
    if (this.previewIndex <= 0) {
      return;
    }

    this.previewIndex--;

    const document =
      this.filteredDocuments[this.previewIndex];

    this.selectedDocument = document;

    this.loadDocumentPreview(document);
  }

  nextPreview(): void {
    if (
      this.previewIndex >=
      this.filteredDocuments.length - 1
    ) {
      return;
    }

    this.previewIndex++;

    const document =
      this.filteredDocuments[this.previewIndex];

    this.selectedDocument = document;

    this.loadDocumentPreview(document);
  }


  closePreview(): void {
    this.showPreviewModal = false;
    this.selectedDocument = null;
    this.previewIndex = 0;
  }

  hasPreviewContent(): boolean {

    if (!this.selectedDocument) {
      return false;
    }

    const fileType = this.selectedDocument.file_type;

    if (fileType === 'video') {
      return !!this.inputSrc;
    }

    if (fileType === 'audio') {
      return !!this.inputSrc;
    }

    if (fileType === 'image') {
      return !!this.mediaContent?.view_Url;
    }

    if (fileType === 'application') {
      return !!this.selectedReadFile;
    }

    return false;
  }

  loadDocumentPreview(document: any): void {
    if (!document) {
      return;
    }

    console.log(document, ':::::dc::::');

    // Reset previous preview
    this.inputSrc = '';
    this.selectedReadFile = '';
    this.mediaContent = null;

    const fileType = String(document.file_type || '').toLowerCase();

    switch (fileType) {

      // ============================
      // VIDEO
      // ============================
      case 'video':
        this.inputSrc =
          document.view_Url ||
          document.view_url ||
          document.file_url ||
          document.url ||
          '';

        break;

      // ============================
      // AUDIO
      // ============================
      case 'audio':
        this.inputSrc =
          document.view_Url ||
          document.view_url ||
          document.file_url ||
          document.url ||
          '';

        break;

      // ============================
      // IMAGE
      // ============================
      case 'image':
        this.mediaContent = {
          ...document,
          view_Url:
            document.view_Url ||
            document.view_url ||
            document.file_url ||
            document.url ||
            ''
        };

        break;

      // ============================
      // APPLICATION / PDF / DOC
      // ============================
      case 'application':
        this.selectedReadFile =
          document.view_Url ||
          document.view_url ||
          document.file_url ||
          document.url ||
          '';

        break;

      default:
        console.warn(
          'Unsupported document type:',
          document.file_type
        );
        break;
    }
  }


  /**
   * Select / unselect individual document
   */
  toggleDocumentSelection(document: any, event: Event): void {

    event.stopPropagation();

    const checkbox = event.target as HTMLInputElement;

    const id = document?.llmfile_uuid;

    if (!id || !this.isSelectableDocument(document)) {
      checkbox.checked = false;
      return;
    }

    const selectedIds = new Set(
      this.llmService.selectedDoc_ids || []
    );

    // ==========================================
    // SELECT DOCUMENT
    // ==========================================
    if (checkbox.checked) {

      selectedIds.add(id);

      this.llmService.selectedDoc_name_map[id] =
        document?.message ||
        document?.document_file_name ||
        '';

      this.llmService.selectedDoc_summary_category_map[id] =
        document?.summary_category || '';

    }

    // ==========================================
    // UNSELECT DOCUMENT
    // ==========================================
    else {

      selectedIds.delete(id);

      delete this.llmService.selectedDoc_name_map[id];

      delete this.llmService.selectedDoc_summary_category_map[id];
    }

    // ==========================================
    // UPDATE SERVICE STATE
    // ==========================================

    this.llmService.selectedDoc_ids =
      Array.from(selectedIds);

    this.llmService.saveSelectedDocs();

    this.updateSelectedDocuments();
  }


  /**
   * Select / unselect all visible documents
   */
  toggleSelectAll(event: Event): void {

    const checkbox = event.target as HTMLInputElement;

    const selectableDocuments = (this.filteredDocuments || [])
      .filter((document: any) =>
        this.isSelectableDocument(document)
      );

    if (!selectableDocuments.length) {
      return;
    }

    const selectedIds = new Set(
      this.llmService.selectedDoc_ids || []
    );

    // ==========================================
    // SELECT ALL
    // ==========================================
    if (checkbox.checked) {

      selectableDocuments.forEach((document: any) => {

        const id = document.llmfile_uuid;

        selectedIds.add(id);

        this.llmService.selectedDoc_name_map[id] =
          document?.message ||
          document?.document_file_name ||
          '';

        this.llmService.selectedDoc_summary_category_map[id] =
          document?.summary_category || '';
      });

    }

    // ==========================================
    // UNSELECT ALL
    // ==========================================
    else {

      selectableDocuments.forEach((document: any) => {

        const id = document.llmfile_uuid;

        selectedIds.delete(id);

        delete this.llmService.selectedDoc_name_map[id];

        delete this.llmService.selectedDoc_summary_category_map[id];
      });
    }

    this.llmService.selectedDoc_ids =
      Array.from(selectedIds);

    this.llmService.saveSelectedDocs();

    this.updateSelectedDocuments();
  }


  /**
   * Delete selected documents
   */
  deleteSelectedDocuments(): void {

    if (!this.selectedDocuments.length) {
      return;
    }

    console.log(
      'Selected documents:',
      this.selectedDocuments
    );

    const documentIds = this.selectedDocuments.map(
      document => document.message_id
    );

    // this.confirmDialogService.openConfirmDialog('', {
    //   title: 'Confirmation',
    //   message: `Are you sure you want to delete this "${selectedDocuments.full_name}" Documents ?`,
    //   btnOkText: 'YES',
    //   btnCancelText: 'NO'
    // })

    console.log('Selected document IDs:', documentIds);

    // Call your bulk delete API here
  }


  isSelectableDocument(document: any): boolean {
    const fileType =
      String(document?.file_type || '')
        .toLowerCase();

    return (
      fileType !== 'video' &&
      fileType !== 'image' &&
      !!document?.llmfile_uuid
    );
  }

  isDocumentSelected(document: any): boolean {
    if (!document?.llmfile_uuid) {
      return false;
    }

    return (this.llmService.selectedDoc_ids || [])
      .includes(document.llmfile_uuid);
  }

  isAllDocumentsSelected(): boolean {
    const selectableDocuments = (this.filteredDocuments || [])
      .filter((document: any) =>
        this.isSelectableDocument(document)
      );

    if (selectableDocuments.length === 0) {
      return false;
    }

    const selectedIds = new Set(
      this.llmService.selectedDoc_ids || []
    );

    return selectableDocuments.every(
      (document: any) =>
        selectedIds.has(document.llmfile_uuid)
    );
  }

  isSomeDocumentsSelected(): boolean {
    const selectableDocuments = (this.filteredDocuments || [])
      .filter((document: any) =>
        this.isSelectableDocument(document)
      );

    if (selectableDocuments.length === 0) {
      return false;
    }

    const selectedIds = new Set(
      this.llmService.selectedDoc_ids || []
    );

    const selectedCount = selectableDocuments.filter(
      (document: any) =>
        selectedIds.has(document.llmfile_uuid)
    ).length;

    return (
      selectedCount > 0 &&
      selectedCount < selectableDocuments.length
    );
  }

  updateSelectedDocuments(): void {

    const selectedIds = new Set(
      this.llmService.selectedDoc_ids || []
    );

    this.selectedDocuments = (this.documents || [])
      .filter((document: any) =>
        document?.llmfile_uuid &&
        selectedIds.has(document.llmfile_uuid)
      );
  }






  openCreateFolder(): void {

    this.newFolderName = '';
    this.newFolderDescription = '';
    this.newFolderModelType = '';
    this.newFolderAccess = 'users';

    this.userSearch = '';
    this.selectedFolderUsers = [];

    this.showFolderModal = true;

    const payload = {
      offset: 0,
      limit: this.limit,
      search: ''
    };

    this.httpLoader.showLoader();

    this.userservice
      .getActiveUserList(payload)
      .pipe(
        finalize(() => {
          this.httpLoader.hideLoader();
        })
      )
      .subscribe({
        next: (response: any) => {

          this.listOfUsers =
            Array.isArray(response?.userList)
              ? response.userList
              : [];
        },

        error: (error: any) => {

          console.error(
            'Failed to load users:',
            error
          );

          this.listOfUsers = [];

          this.alert.showAlertMessage({
            message:
              error?.error?.message ||
              error?.message ||
              'Failed to load users.'
          });
        }
      });
  }

  openEditFolderModal(folder: any): void {

  if (!folder?.group_id) {
    this.alert.showAlertMessage({
      message: 'Invalid document folder.'
    });
    return;
  }

  // =========================================================
  // EDIT MODE
  // =========================================================
  this.isEditFolder = true;
  this.editingFolderId = folder.group_id;

  this.newFolderName = folder.full_name || '';

  this.newFolderDescription =
    folder.description ??
    folder.chat_description ??
    '';

  this.newFolderModelType = String(
    folder.model_type ?? '1'
  );

  this.newFolderAccess =
    folder.access_type === 'all'
      ? 'all'
      : 'users';

  this.selectedFolderUsers = [];
  this.userSearch = '';

  this.showFolderModal = true;

  // =========================================================
  // LOAD USERS + ASSIGNED USERS
  // =========================================================
  this.loadFolderUsersForEdit(folder.group_id);
}

private loadFolderUsersForEdit(groupId: any): void {

  const payload = {
    groupId: groupId,
    offset: 0,
    limit: 1000
  };

  this.chatService.getMessageAttachments(payload).subscribe({
    next: (response: any) => {

      const groupUserDetail =
        Array.isArray(response?.groupUserDetail)
          ? response.groupUserDetail
          : [];

      // =====================================================
      // GET ASSIGNED USER IDS
      // =====================================================
      const assignedUserIds = groupUserDetail
        .map((user: any) =>
          user?.user_id ??
          user?.userId ??
          user?.id
        )
        .filter((id: any) => id != null)
        .map((id: any) => String(id));

      this.selectedFolderUsers = assignedUserIds;

      // =====================================================
      // IMPORTANT:
      // Make sure assigned users exist in listOfUsers
      // =====================================================
      this.mergeAssignedUsersIntoList(groupUserDetail);

      // =====================================================
      // RE-APPLY CHECKED STATE
      // =====================================================
      this.syncSelectedUsers();
    },

    error: (error: any) => {

      console.error(
        'Failed to load folder users:',
        error
      );

      this.selectedFolderUsers = [];
    }
  });
}


private mergeAssignedUsersIntoList(
  assignedUsers: any[]
): void {

  if (!Array.isArray(assignedUsers) ||
      !assignedUsers.length) {
    return;
  }

  const currentUsers = Array.isArray(this.listOfUsers)
    ? [...this.listOfUsers]
    : [];

  const existingIds = new Set(
    currentUsers
      .map((user: any) =>
        user?.user_id ??
        user?.userId ??
        user?.id
      )
      .filter((id: any) => id != null)
      .map((id: any) => String(id))
  );

  assignedUsers.forEach((assignedUser: any) => {

    const userId =
      assignedUser?.user_id ??
      assignedUser?.userId ??
      assignedUser?.id;

    if (userId == null) {
      return;
    }

    const normalizedId = String(userId);

    // Already available in user list
    if (existingIds.has(normalizedId)) {
      return;
    }

    // Add assigned user to the available list
    currentUsers.push({
      ...assignedUser,
      user_id: userId,
      first_name:
        assignedUser.first_name ??
        assignedUser.firstname ??
        '',
      last_name:
        assignedUser.last_name ??
        assignedUser.lastname ??
        '',
      email:
        assignedUser.email ??
        ''
    });

    existingIds.add(normalizedId);
  });

  this.listOfUsers = currentUsers;
}

private syncSelectedUsers(): void {

  const selectedIds = new Set(
    (this.selectedFolderUsers || [])
      .map(id => String(id))
  );

  this.selectedFolderUsers =
    (this.listOfUsers || [])
      .map((user: any) =>
        user?.user_id ??
        user?.userId ??
        user?.id
      )
      .filter((id: any) =>
        id != null &&
        selectedIds.has(String(id))
      )
      .map((id: any) => String(id));
}

  documentPublish(document: any, index: number): void {
    try {
      console.log('Document:', document);
      console.log('Index:', index);

      this.confirmDialogService.openConfirmDialog('', {
        title: 'Confirmation',
        message: 'Do you want to publish this document?',
        btnOkText: 'YES',
        btnCancelText: 'NO',

        onClose: (confirmed: boolean) => {
          if (!confirmed) {
            return;
          }

          const payLoad: any = {
            group_id: this.selectedFolderId,
            file_id: document.message_id
          };

          this.chatService.editUploadFileList(payLoad).subscribe({
            next: (data: any) => {

              const payload = data?.record;

              if (!payload) {
                this.alert.showAlertMessage({
                  message: 'Unable to publish document.'
                });
                return;
              }

              this.editedData = payload;
              this.editedMessageId = payload.message_id ?? 0;

              this.chatService.updateUploadFileData({
                ...payload,
                is_publish: true
              }).subscribe({
                next: (response: any) => {

                  // Update current document
                  document.is_publish = true;

                  // If you specifically want to update by index
                  if (this.filteredDocuments?.[index]) {
                    this.filteredDocuments[index].is_publish = true;
                  }

                  // Also update original list if required
                  const documentIndex = this.documents?.findIndex(
                    (item: any) => item.message_id === document.message_id
                  );

                  if (documentIndex !== -1) {
                    this.documents[documentIndex].is_publish = true;
                  }

                  this.alert.showAlertMessage({
                    message: 'Document published successfully'
                  });
                },

                error: (error: any) => {
                  console.error('Publish update failed:', error);

                  this.alert.showAlertMessage({
                    message: 'Failed to publish document.'
                  });
                }
              });
            },

            error: (error: any) => {
              console.error('Edit upload file failed:', error);

              this.alert.showAlertMessage({
                message: 'Failed to publish document.'
              });
            }
          });
        }
      });

    } catch (error) {
      this.httpLoader.hideLoader();
      console.error('documentPublish error:', error);
    }
  }

}
